// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header ion-title {
  font-weight: 300;
  font-size: 17px;
  line-height: 25.5px;
}

ion-content ion-card {
  margin: 0;
  box-shadow: none;
  position: fixed;
  z-index: 999;
  overflow: hidden;
  min-width: 100%;
  border-radius: 0;
}
ion-content ion-card .custom {
  padding: 20px;
  min-width: 100%;
  max-height: 45px;
  border: 2px dashed var(--ion-color-primary);
  border-radius: 0;
}
ion-content ion-item {
  --inner-padding-start: 0;
  --inner-padding-end: 0;
  --padding-start: 0;
  --padding-end: 0;
}
ion-content ion-item .input {
  width: 100%;
  height: 5vh;
  padding: 15px;
  border-radius: 5px;
  border: 1px solid #ccc;
}
ion-content .map {
  height: 95vh;
  width: 100%;
}
ion-content #infowindow-content #place-name {
  margin-left: 6px;
  font-size: 16px;
}
ion-content #infowindow-content #place-address {
  font-weight: 400;
  font-size: 14px;
}

ion-footer ion-button {
  min-height: 52px;
  font-size: 22px;
  --border-radius: 64px;
  --background: var(--ion-color-primary);
  --background-activated: var(--ion-color-secondary);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/autocomplete/autocomplete.page.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;AAAR;;AAKI;EACI,SAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAFR;AAIQ;EACI,aAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;EACA,gBAAA;AAFZ;AAMI;EACI,wBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AAJR;AAMQ;EACI,WAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;AAJZ;AAQI;EACI,YAAA;EACA,WAAA;AANR;AAWQ;EACI,gBAAA;EACA,eAAA;AATZ;AAYQ;EACI,gBAAA;EACA,eAAA;AAVZ;;AAgBI;EACI,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,sCAAA;EACA,kDAAA;AAbR","sourcesContent":["ion-header {\n    ion-title {\n        font-weight: 300;\n        font-size: 17px;\n        line-height: 25.5px;\n    }\n}\n\nion-content {\n    ion-card {\n        margin: 0;\n        box-shadow: none;\n        position: fixed;\n        z-index: 999;\n        overflow: hidden;\n        min-width: 100%;\n        border-radius: 0;\n\n        .custom {\n            padding: 20px;\n            min-width: 100%;\n            max-height: 45px;\n            border: 2px dashed var(--ion-color-primary);\n            border-radius: 0;\n        }\n    }\n\n    ion-item {\n        --inner-padding-start: 0;\n        --inner-padding-end: 0;\n        --padding-start: 0;\n        --padding-end: 0;\n\n        .input {\n            width: 100%;\n            height: 5vh;\n            padding: 15px;\n            border-radius: 5px;\n            border: 1px solid #ccc;\n        }\n    }\n\n    .map {\n        height: 95vh;\n        width: 100%;\n    }\n\n    #infowindow-content {\n\n        #place-name {\n            margin-left: 6px;\n            font-size: 16px;\n        }\n\n        #place-address {\n            font-weight: 400;\n            font-size: 14px;\n        }\n    }\n}\n\nion-footer {\n    ion-button {\n        min-height: 52px;\n        font-size: 22px;\n        --border-radius: 64px;\n        --background: var(--ion-color-primary);\n        --background-activated: var(--ion-color-secondary);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
